import {AbstractPointResponse} from './abstracts/abstract-point-response';

export class TextPointResponse extends AbstractPointResponse {

  public constructor() {
    super();
  }
}
